type Coord = [number, number];
type Shape = Coord[];

export const shapes: Record<string, Shape> = {
  I: [
    [0, 0],
    [0, 1],
    [0, 2],
    [0, 3],
  ],

  J: [
    [1, 0],
    [1, 1],
    [0, 2],
    [1, 2],
  ],

  L: [
    [0, 0],
    [0, 1],
    [0, 2],
    [1, 2],
  ],

  O: [
    [0, 0],
    [1, 0],
    [0, 1],
    [1, 1],
  ],

  T: [
    [0, 0],
    [1, 0],
    [2, 0],
    [1, 1],
  ],

  S: [
    [1, 0],
    [2, 0],
    [0, 1],
    [1, 1],
  ],

  Z: [
    [0, 0],
    [1, 0],
    [1, 1],
    [2, 1],
  ],
};
